// extracted by mini-css-extract-plugin
module.exports = {"equipment-icon-card":"BestSellerNotification_equipment-icon-card__HXzYZ"};